import React, { useEffect, useState } from "react";
import api from "../api/axios";
import { Link } from "react-router-dom";
// SWEET ALERT 2
import Swal from "sweetalert2";
// --- Import Images Here ---
import AuthCover1 from "./../assets/UserPanelAssets/img/auth/cover-imgs-1.png";
import AuthCover2 from "./../assets/UserPanelAssets/img/auth/cover-imgs-2.png";
import Logo from "../assets/images/Bharat_Dhara/Logo/bd_xxl_png.png";
import SocialLogin from "../components/SocialLogin";

export default function Login() {
  const [formState, setFormState] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  useEffect(() => {
    const NavHeader = document.querySelector(".navbar-header");
    const Sidebar = document.getElementById("sidebar");
    const Footer = document.querySelector(".footer");
    const PageWrapper = document.querySelector(".page-wrapper");
    NavHeader.classList.add("d-none");
    Sidebar.classList.add("d-none");
    Footer.classList.add("d-none");
    PageWrapper.style.margin = "0 0 0 0";
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const changePasswordVisability = () => {
    setShowPassword((prev) => !prev);
  };

  async function handleSubmit(e) {
    e.preventDefault();
    let Response;
    try {
      const response = await api.post("customer/login", formData);
      Response = response.data;
    } catch (error) {
      // console.error("Error:", error);
      Response = error.response.data;
    }
    console.log("Response", Response);
    Swal.fire({
      icon: Response.status,
      title: Response.message,
      footer: '<a href="/login-guide">Why do I have this issue?</a>',
    }).then((result) => {
      // If user clicks OK
      if (result.isConfirmed) {
        if (Response.status === "success") {
          // Save token
          localStorage.setItem("token", Response.token);
          // Redirect
          window.location.href = "/dashboard";
        }
      }
    });
  }

  return (
    <div className="main-wrapper auth-bg position-relative overflow-hidden">
      <div className="container-fuild position-relative z-1">
        <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100 bg-white">
          <div className="row">
            {/* LEFT SIDE */}
            <div className="col-lg-6 p-0">
              <div className="login-backgrounds login-covers bg-primary d-lg-flex align-items-center justify-content-center d-none flex-wrap p-4 position-relative h-100 z-0">
                <div className="authentication-card w-100">
                  <div className="authen-overlay-item w-100">
                    <div className="authen-head text-center">
                      <h1 className="text-white fs-32 fw-bold mb-2">
                        Seamless healthcare access <br />
                        with Bharat Dhara's smart, modern clinic
                      </h1>
                      <p className="text-light fw-normal">
                        Experience efficient, secure, and user-friendly
                        healthcare management designed for modern clinics and
                        growing practices.
                      </p>
                    </div>

                    <div className="mt-4 mx-auto authen-overlay-img">
                      <img src={AuthCover1} alt="Auth Illustration 1" />
                    </div>
                  </div>
                </div>

                <img
                  src={AuthCover2}
                  alt="Auth Illustration 2"
                  className="img-fluid cover-img"
                />
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="row justify-content-center align-items-center overflow-auto flex-wrap vh-100">
                <div className="col-md-8 mx-auto">
                  <form
                    className="d-flex justify-content-center align-items-center"
                    onSubmit={handleSubmit}
                  >
                    <div className="d-flex flex-column justify-content-lg-center p-4 p-lg-0 pb-0 flex-fill">
                      <div className="mx-auto mb-4 text-center">
                        <img
                          src={Logo}
                          className="img-fluid registerPageLogo"
                          alt="Logo"
                        />
                      </div>

                      <div className="card border-1 p-lg-3 shadow-md rounded-3 m-0">
                        <div className="card-body">
                          <div className="text-center mb-3">
                            <h5 className="mb-1 fs-20 fw-bold">Sign In</h5>
                            <p className="mb-0">
                              Please enter below details to access the dashboard
                            </p>
                          </div>

                          {/* EMAIL */}
                          <div className="mb-3">
                            <label className="form-label">Email Address</label>
                            <div className="input-group">
                              <span className="input-group-text border-end-0 bg-white">
                                <i className="ti ti-mail fs-14 text-dark"></i>
                              </span>
                              <input
                                type="text"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="form-control border-start-0 ps-0"
                                placeholder="Enter Email Address"
                              />
                            </div>
                          </div>

                          {/* PASSWORD */}
                          <div className="mb-3">
                            <label className="form-label">Password</label>
                            <div className="position-relative">
                              <div className="pass-group input-group position-relative border rounded">
                                <span className="input-group-text bg-white border-0">
                                  <i className="ti ti-lock text-dark fs-14"></i>
                                </span>
                                <input
                                  id="customerPassword"
                                  type={showPassword ? "text" : "password"}
                                  name="password"
                                  value={formData.password}
                                  onChange={handleChange}
                                  className="pass-input form-control ps-0 border-0"
                                  required
                                />
                                <span
                                  className="input-group-text bg-white border-0"
                                  onClick={changePasswordVisability}
                                >
                                  <i className="ti toggle-password ti-eye-off text-dark fs-14"></i>
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* REMEMBER + FORGOT */}
                          <div className="d-flex align-items-center justify-content-between mb-3">
                            <div className="form-check form-check-md mb-0">
                              <input
                                className="form-check-input"
                                id="remember_me"
                                type="checkbox"
                              />
                              <label
                                htmlFor="remember_me"
                                className="form-check-label mt-0 text-dark"
                              >
                                Remember Me
                              </label>
                            </div>

                            {/* <div className="text-end">
                              <a href="#" className="text-danger">
                                Forgot Password?
                              </a>
                            </div> */}
                          </div>

                          <button
                            type="submit"
                            className="btn bg-primary text-white w-100 mb-3"
                          >
                            Login
                          </button>

                          {/* OR */}
                          <div className="login-or position-relative mb-3">
                            <span className="span-or">OR</span>
                          </div>

                          <SocialLogin />

                          <div className="text-center">
                            <h6 className="fw-normal fs-14 text-dark mb-0">
                              Don’t have an account yet?{" "}
                              <Link to="/register" className="hover-a">
                                Register
                              </Link>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>

                  <p className="fs-14 text-dark text-center mt-4">
                    Copyright © 2025 - Bharat Dhara.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* end row */}
        </div>
      </div>
    </div>
  );
}
